import { createRoutesWithHeader } from "./CreateRoutes";
import {
    UnderConstruction,
    LandingMain,
    Imprint,
    Datenschutz
} from "../pages/index"
import { NotFoundPage } from "../pages/NotFound/NotFound";

export const routesWithHeader = [
    createRoutesWithHeader('/notready', UnderConstruction),
    createRoutesWithHeader('/', LandingMain),
    createRoutesWithHeader('/Impressum', Imprint),
    createRoutesWithHeader('/Datenschutz', Datenschutz),
    createRoutesWithHeader('*', NotFoundPage)
];